/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateExecutionRequestBase {
    getFixupPrototypeFunction() { return TemplateExecutionRequestBase.fixupPrototype; }

    static newInstance(model: Partial<TemplateExecutionRequestBase>): TemplateExecutionRequestBase {
        let obj = Object.assign(new TemplateExecutionRequestBase(), model);
        TemplateExecutionRequestBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateExecutionRequestBase>): TemplateExecutionRequestBase {
        if (!model) return null;
        return TemplateExecutionRequestBase.newInstance(<TemplateExecutionRequestBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateExecutionRequestBase) {
        if (!obj) return;

        models.TemplateExecutionRequestBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateExecutionRequestBase): boolean {
        Object.setPrototypeOf(obj, TemplateExecutionRequestBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.service_accounts) {
            for (let val of this.service_accounts) {
                models.TemplateServiceAccount.fixupPrototype(val);
            }
        }
    }

    /**
     * Template parameter values for this execution, encoded as a JSON string, e.g. '{\"ClusterName\": \"prod\", \"AdditionalNodes\": 3}'. Parameter names, types, and requiredness come from the template's own stored schema (see Get Params) - not resent by the caller.
     */
    args: string;

    /**
     * Service accounts to run against. Required.
     */
    service_accounts: Array<models.TemplateServiceAccount>;

}
